import { Component, effect, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';

import { environment } from '@environment';
import { PageBaseComponent } from '../base/page-base/page-base.component';
import { DynamicPageComponent } from '../dynamic-page/dynamic-page.component';
import { hasAccountSelected, isLoggedIn } from '@services/can-activate.guard';
import { UserService } from '@services/user.service';
import { GlobalService } from '@services/global.service';
import { AccountService } from '@services/account.service';
import { GeneralInfo } from '@models/general-info';
import { SetupInfo } from '@models/setup-info';
import { Account } from '@models/account';
import { IValidatedUser } from '@models/validated-user';

@Component({
    selector: 'cp-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less'],
    standalone: false
})
export class HomeComponent extends PageBaseComponent implements OnInit {
    backgroundColor: string = 'rgb(170, 0, 0)';
    hoverColor: string = 'rgb(136, 0, 0)';
    disabledBackgroundColor: string = 'rgba(170, 0, 0, 0.5)';

    multipleAccountsAvailable: boolean = false;

    currentAccount: Account;
    generalInfo: GeneralInfo;
    menuItems: SetupInfo[];

    get isAccountSelected(): boolean {
        return this.currentAccount !== null && this.currentAccount !== undefined;
    }

    get isUSNR(): boolean {
        return environment.System.toLowerCase() === "usnr";
    }

    get isBMS(): boolean {
        return environment.System.toLowerCase() === "bms";
    }

    constructor(
        private _router: Router,
        private _userService: UserService,
        private _globalService: GlobalService
    ) {
        super();

        effect(() => {
            this.currentAccount = this._userService.AccountNumber$();
        });

        effect(() => {
            this.menuItems = this._userService.SetupInfoItems$().filter((i: SetupInfo) => !this.isInvalid(i.buttonLabel));
        });
    }

    override ngOnInit(): void {
        let currentUser: IValidatedUser = this._userService.getCurrentUser();
        if (currentUser) {
            this._userService.getAccountsForUser('', currentUser.UserId).subscribe(
                (accounts: Account[]) => {
                    this.multipleAccountsAvailable = accounts.length > 1;
                }
            );
        }

        this.initialize();
    }

    protected override initialize(): void {
        this._globalService.getGeneralInfo().subscribe(
            (response: GeneralInfo) => {
                this.generalInfo = response;
            }
        );
    }

    // private getReportSetup(): void {
    //     if (this.currentAccount) {
    //         this._accountService.getReportSetupForAccount(this.currentAccount.AccountNumber, this._globalService.getLanguageCode() ).subscribe(
    //             (setupInfo: SetupInfo[]) => {
    //                 let routes: Route[] = [];
    //                 setupInfo.forEach((info: SetupInfo) => {
    //                     this.menuItems.push(info);
    //                     routes.push({path: info.route, component: DynamicPageComponent, data: { details: info.details }, canActivate: [ isLoggedIn, hasAccountSelected]});
    //                 });
    //                 let currentRoutes: Route[] = this._router.config;
    //                 this._router.resetConfig([...routes, ...currentRoutes]);
    //             }
    //         );
    //     }
    // }

    private isInvalid(value: string): boolean {
        return value === undefined || value === null || value === '';
    }

    goto(route: string): void {
        this._router.navigate([ route ]);
    }

    gotoAccountSelector(): void {
        this._router.navigate(['accounts']);
    }
}
